import { useTranslation } from 'react-i18next';
import { Home, Cloud, UtensilsCrossed, Scale, ShoppingCart, GraduationCap, Heart, Building2 } from 'lucide-react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef } from 'react';

const IndustrySolutions = () => {
  const { t } = useTranslation();
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  const industries = t('industries.items', { returnObjects: true }) as any[];

  const iconMap: { [key: string]: any } = {
    realestate: Home,
    saas: Cloud,
    restaurant: UtensilsCrossed,
    legal: Scale,
    ecommerce: ShoppingCart,
    education: GraduationCap,
    healthcare: Heart,
    insurance: Building2,
  };

  // すべての業界を表示
  const mainIndustries = industries;

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: "easeOut"
      }
    }
  };

  return (
    <section className="py-32 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.h2 
          className="text-4xl md:text-5xl lg:text-6xl font-black text-center text-gray-900 mb-20 tracking-tight"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6, ease: "easeOut" }}
        >
          {t('industries.title')}
        </motion.h2>

        <motion.div 
          ref={ref}
          className="grid md:grid-cols-2 lg:grid-cols-3 gap-8"
          variants={containerVariants}
          initial="hidden"
          animate={isInView ? "visible" : "hidden"}
        >
          {mainIndustries.map((industry: any, index: number) => {
            const Icon = iconMap[industry.icon] || Home;
            return (
              <motion.div
                key={index}
                className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all hover:scale-105 border border-gray-100"
                variants={itemVariants}
                whileHover={{ scale: 1.05, y: -10 }}
                transition={{ duration: 0.2 }}
              >
                <motion.div 
                  className="mb-6"
                  whileHover={{ scale: 1.1, rotate: 5 }}
                  transition={{ duration: 0.2 }}
                >
                  <div className="inline-block bg-gradient-to-br from-blue-500 to-cyan-500 rounded-2xl p-4">
                    <Icon size={40} className="text-white" />
                  </div>
                </motion.div>
                <h3 className="text-2xl font-black text-gray-900 mb-4">
                  {industry.name}
                </h3>
                <p className="text-gray-700 leading-relaxed mb-4">
                  {industry.problem}
                </p>
                <p className="text-blue-600 font-bold">
                  {industry.solution}
                </p>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
};

export default IndustrySolutions;

